import { fetchPublicKey } from "@Src/utils/encryption";
import {
	createContext,
	type ReactNode,
	useContext,
	useEffect,
	useState,
} from "react";

type PublicKeyContextValue = {
	publicKey: string | null;
};

const PublicKeyContext = createContext<PublicKeyContextValue | undefined>(
	undefined,
);

export const PublicKeyProvider = ({ children }: { children: ReactNode }) => {
	const [publicKey, setPublicKey] = useState<string | null>(null);

	useEffect(() => {
		fetchPublicKey().then(setPublicKey);
	}, []);

	return (
		<PublicKeyContext.Provider value={{ publicKey }}>
			{children}
		</PublicKeyContext.Provider>
	);
};

export const usePublicKey = () => {
	const ctx = useContext(PublicKeyContext);
	if (!ctx)
		throw new Error("usePublicKey must be used inside PublicKeyProvider");
	return ctx;
};
